import React from "react";
import { Divider, Form, Input, Row, Col, Button, message } from 'antd';
import CustomBadge from 'components/CustomBadge';
import { config } from 'util/config';
import * as globalFunction from 'util/GlobalFunction';
import AntDraggableModal from 'components/AntDraggableModal';
import { httpClient } from "util/Api";
import moment from 'moment';
import CreatePage from './CreatePage';

export default class BookingRequest extends React.Component {
  constructor(props) {
    super();
    this.state = {
      loaded: false,
      loading: true,
      submitting: false,
      moduleId: 0,
      webUIConfig: null,
      formData: {},
      type: '',
      publicHoliday: [],
      cutoffHours: 16,
      cutoffMinutes: 0
    }

    this.formRef = React.createRef();
    this.createPage = React.createRef();
  };

  //查询该页面的config
  componentDidMount() {
  }

  getWebUI(type) {
    console.log(this.props.pageComponent.state, 'this.props.pageComponent.state----')
    let publicHoliday = this.props.pageComponent.state.publicHoliday;
    this.setState({ publicHoliday });

    this.setState({ type, loaded: false });
    let that = this;
    httpClient
      .get('/System/WebUI/GetPublicBookingRequestWebUI?accessCode=' + this.props.pageComponent.props.accessCode + '&type=' + type)
      .then(({ data }) => {
        if (data.result) {
          let publicLodgeWebUI = data.data;
          const decodedString = atob(publicLodgeWebUI.webUIConfig);
          publicLodgeWebUI.webUIConfig = JSON.parse(decodedString);
          this.setState({ webUIConfig: publicLodgeWebUI.webUIConfig, companyId: publicLodgeWebUI.CompanyId, moduleId: publicLodgeWebUI.ModuleId, cutoffHours: publicLodgeWebUI.CutoffHours, cutoffMinutes: publicLodgeWebUI.CutoffMinutes, loaded: true, loading: false });
          if (type === 'Edit') {
            setTimeout(() => {
              let formData = this.props.subjobData;
              switch (this.props.pageComponent.state.jobData.ModuleConfig.SubJobDefaultTimeBlock) {
                case "AM":
                  this.formRef.current?.setFieldValue('ScheduledTimeAmPm', 0);
                  break;
                case "PM":
                  this.formRef.current?.setFieldValue('ScheduledTimeAmPm', 1);
                  break;
                case "Anytime":
                  this.formRef.current?.setFieldValue('ScheduledTimeAmPm', 2);
                  break;
                case "Time Block":
                  this.formRef.current?.setFieldValue('ScheduledTimeAmPm', 3);
                  break;
                default:
                  this.formRef.current?.setFieldValue('ScheduledTimeAmPm', 0);
                  break;
              }
              this.createPage.current?.child[0].current?.child.current?.setState({ formData });
            }, config.setTimeoutMilliSecond);
          } else {
            setTimeout(() => {
              let formData = {};
              switch (this.props.pageComponent.state.jobData.ModuleConfig.SubJobDefaultTimeBlock) {
                case "AM":
                  this.formRef.current?.setFieldValue('ScheduledTimeAmPm', 0);
                  break;
                case "PM":
                  this.formRef.current?.setFieldValue('ScheduledTimeAmPm', 1);
                  break;
                case "Anytime":
                  this.formRef.current?.setFieldValue('ScheduledTimeAmPm', 2);
                  break;
                case "Time Block":
                  this.formRef.current?.setFieldValue('ScheduledTimeAmPm', 3);
                  break;
                default:
                  this.formRef.current?.setFieldValue('ScheduledTimeAmPm', 0);
                  break;
              }
              this.scheduledTimeAmPmOnChange(this.formRef.current?.getFieldValue('ScheduledTimeAmPm'))
              this.createPage.current?.child[0].current?.child.current?.setState({ formData });
            }, config.setTimeoutMilliSecond);
          }
        } else {
          this.setState({ loaded: true, loading: false });
          globalFunction.handleResultError(data, this);
        }
      })
      .catch(function (error) {
        that.setState({ loaded: true, loading: false });
        globalFunction.handleError(error, that);
      });
  }

  scheduledTimeAmPmOnChange(option) {
    switch (option) {
      case 0:
        this.formRef.current?.setFieldValue('ScheduledTime', [moment('06:00', 'HH:mm'), moment('12:00', 'HH:mm')]);
        break;
      case 1:
        this.formRef.current?.setFieldValue('ScheduledTime', [moment('12:00', 'HH:mm'), moment('18:00', 'HH:mm')]);
        break;
      case 2:
        this.formRef.current?.setFieldValue('ScheduledTime', [moment('06:00', 'HH:mm'), moment('18:00', 'HH:mm')]);
        break;
      case 3:
        this.formRef.current?.setFieldValue('ScheduledTime', undefined);
        break;
    }
  }

  //自动填充Inspection Name
  inspectionNameOnChange({ sectionName, parameter, sectionComponent, pageComponent, uie }) {
    if (!uie.autoDataSource && uie.datasourceUrl !== null) {
      httpClient
        .get(uie.datasourceUrl + '?keyword=' + parameter + '&companyId=' + pageComponent.state.companyId + '&moduleId=' + pageComponent.state.moduleId)
        .then(({ data }) => {
          let options = [];
          if (data.result) {
            data.data.map((subJobType, j) => {
              options.push({ label: subJobType.Name, value: subJobType.Name, data: subJobType });
            })
            let componentDataSource = this.createPage.current?.child[0].current?.state.componentDataSource;
            componentDataSource.Name = options;
            this.createPage.current?.child[0].current?.setState({ componentDataSource });
          } else {
            globalFunction.handleResultError(data, pageComponent);
          }
        })
        .catch(function (error) {
          globalFunction.handleError(error, pageComponent);
        });
    } else {
      let componentDataSource = this.createPage.current?.child[0].current?.state.componentDataSource;
      componentDataSource.Name = [];
      this.createPage.current?.child[0].current?.setState({ componentDataSource });
    }
  }

  //提交表单
  onFinish = async (values: any) => {
    //处理一些特殊的自定义字段
    let form = values;
    form.accessCode = this.props.pageComponent.props.accessCode;
    let url = '';
    switch (this.state.type) {
      case 'Create':
        url = '/Business/SubJob/PublicCreateBookingRequest';
        break;
      case 'Edit':
        form.SubJobId = this.props.subjobData.SubJobId;
        url = '/Business/SubJob/PublicEditBookingRequest';
        break;
    }


    this.state.page.sectionList[0].componentList[0].groupList.filter(c => c.show).forEach(group => {
      group.uieList.forEach(uie => {
        if (uie.component === 'DatePicker') {
          if (form[uie.source] !== undefined && form[uie.source] !== null) {
            form[uie.source] = moment(form[uie.source]).format(config.format.sqlDate);
          } else {
            form[uie.source] = null;
          }
        }
        if (uie.component === 'TimePicker') {
          if (form[uie.source] !== undefined && form[uie.source] !== null) {
            switch (uie.type) {
              case 'RangePicker':
                if (form[uie.source][0] !== undefined && form[uie.source][0] !== null && form[uie.source][1] !== undefined && form[uie.source][1] !== null) {
                  let time = moment(form[uie.source][0]).format('HH:mm') + ',' + moment(form[uie.source][1]).format('HH:mm');
                  form[uie.source] = time;
                } else {
                  form[uie.source] = null;
                }
                break;
              default:
                form[uie.source] = moment(form[uie.source]).format('HH:mm');
                break;
            }
          } else {
            form[uie.source] = null;
          }
        }
      });
    });

    this.setState({ submitting: true });
    let that = this;
    httpClient
      .put(url, form)
      .then(({ data }) => {
        if (data.result) {
          this.setState({ submitting: false });
          this.formRef.current?.resetFields();
          let subJobSection = globalFunction.getSectionComponent(this.props.pageComponent, 'SubJob');
          subJobSection.getSectionDataByDefault();
          this.props.component.setState({ bookingRequestShow: false });
        } else {
          globalFunction.handleResultError(data);
          this.setState({ submitting: false });
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, that);
        that.setState({ submitting: false });
      });
  };


  render() {
    return (
      this.state.loaded ?
        <AntDraggableModal
          title="Inspection Booking Request"
          open={this.props.component.state.bookingRequestShow}
          onCancel={() => {
            this.props.component.setState({ bookingRequestShow: false });
          }}
          onOk={() => { this.formRef.current?.submit() }}
          confirmLoading={this.state.submitting}
          width={1000}
          maskClosable={config.component.Modal.maskClosable}
        >
          <Row gutter={[8, 8]}>
            <Col span={24}>
              <div><b>Please note the rules below</b></div>
              <div>
                <ul>
                  <li>Cannot book inspections on Saturday or Sunday</li>
                  <li>Cannot book inspections on public holidays</li>
                  <li>After 4:00 PM, cannot book inspections on the next day</li>
                  <li>If today is Saturday or Sunday, cannot book inspections on the coming Monday</li>
                  <li>Before we attend a <b>Frame inspection,</b> please ensure you send the Frame and Truss Layout</li>
                </ul>
              </div>
            </Col>
            <Form
              ref={this.formRef}
              autoComplete="off"
              onFinish={this.onFinish}
              size={config.component.size}
            >
              <CreatePage
                {...this.props}
                ref={this.createPage}
                module={this.state.module}
                moduleId={this.state.moduleId}
                state={this.state.state}
                searchParameter={this.state.searchParameter}
                defaultFormData={this.state.defaultFormData}
                companyId={this.state.companyId}
                uploadUrl={'/Business/Document/PublicUpload'}
                webUIConfig={this.state.webUIConfig}
                pageComponent={this} />
            </Form>
          </Row>
        </AntDraggableModal> : <></>
    );
  }
}
